import TagManager from 'react-gtm-module';
import { GTM_ID } from 'shared/consts/config';

export const initializeGTM = () => {
  if (!GTM_ID) return;

  if (window.gtmInitialized) {
    console.log('GTM is already initialized.');
    return;
  }

  console.log('Initializing GTM with ID:', GTM_ID);

  const tagManagerArgs = {
    gtmId: GTM_ID,
  };

  TagManager.initialize(tagManagerArgs);

  window.gtmInitialized = true;
};
